import { render, staticRenderFns } from "./Index.bak.vue?vue&type=template&id=6fddb50f&scoped=true&"
import script from "./Index.bak.vue?vue&type=script&lang=js&"
export * from "./Index.bak.vue?vue&type=script&lang=js&"
import style0 from "./Index.bak.vue?vue&type=style&index=0&id=6fddb50f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fddb50f",
  null
  
)

export default component.exports